import { render, staticRenderFns } from "./DeleteIndexMenu.vue?vue&type=template&id=00aca1e8&scoped=true"
import script from "./DeleteIndexMenu.vue?vue&type=script&lang=js"
export * from "./DeleteIndexMenu.vue?vue&type=script&lang=js"
import style0 from "./DeleteIndexMenu.vue?vue&type=style&index=0&id=00aca1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aca1e8",
  null
  
)

export default component.exports